import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoggerApiService } from './services/logger/logger-api.service';

@Injectable({
  providedIn: 'root'
})
export class AppRouteChangeServiceService {
  private isFirst: boolean = true;

  constructor(private router: Router, private loggerApi: LoggerApiService) {}

  public listenToRouterEvents(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (this.isFirst) {
        this.isFirst = false;
        console.log('isFirst');
      } else {
        console.log(event);
        console.log(window.document.URL);
        // (window as any)._elq.trackEvent(window.document.URL);
      }

      // Log route change
      this.loggerApi.sendEventLog({
        event: 'route_change' + (this.isFirst ? '_first_load' : ''),
        routeUrl: event?.url,
        routeUrlAfterRedirects: event?.urlAfterRedirects,
        url: window.location.href,
        timestamp: new Date()
      });
    });
  }
}
